import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import isSourceNode from "../isSourceNode/index.js";
const viewportOrder = ['xs', 'sm', 'md', 'lg', 'xl'];
export const descendingOrderPixelDensityCompare = (pixelDensityA, pixelDensityB) => pixelDensityB - pixelDensityA;
export const descendingOrderViewportCompare = (viewportA, viewportB) => {
  const aIndex = _indexOfInstanceProperty(viewportOrder).call(viewportOrder, viewportA);

  const bIndex = _indexOfInstanceProperty(viewportOrder).call(viewportOrder, viewportB);

  return bIndex - aIndex;
};
/**
 * Compares two nodes to be sorted in descending order based on min-width and pixel density
 */

export const descendingOrderSourceCompare = (nodeA, nodeB) => {
  if (isSourceNode(nodeA) && isSourceNode(nodeB)) {
    const pixelDiff = descendingOrderPixelDensityCompare(nodeA.props.pixelDensity, nodeB.props.pixelDensity);

    if (pixelDiff === 0) {
      return descendingOrderViewportCompare(nodeA.props.viewport, nodeB.props.viewport);
    }

    return pixelDiff;
  }

  if (isSourceNode(nodeA)) {
    return -1;
  }

  if (isSourceNode(nodeB)) {
    return 1;
  }

  return 0;
};